// global
export const platformPath = 'pzzl_platform/';
export const authPath = 'pzzl_auth/';
export const homePath = 'pzzl_homepage/';
export const trackingPath = 'pzzl_tracking/';
export const faqPath = 'pzzl_faq/';
export const utilsPath = 'pzzl_utils/';
export const publicPath = 'pzzl_public_site/';
// courses
export const coursePath = 'pzzl_course/';
export const activityPath = 'pzzl_activity/';
export const quizPath = 'pzzl_activity_quiz/';
export const surveyPath = 'pzzl_activity_survey/';
export const certificatePath = 'pzzl_certificate/';
export const scormPath = 'pzzl_activity_scorm/';
// event
export const eventsPath = 'pzzl_events/';
export const BBBEventsPath = 'pzzl_events_bbb/';
export const activitySessionPath = 'pzzl_activity_session/';
//document
export const documentPath = 'pzzl_document/';
// news & notifications
export const newsPath = 'pzzl_news/';
export const newsletterPath = 'pzzl_newsletter/';
export const notificationPath = 'pzzl_notification/';
// groups
export const groupsPath = 'pzzl_groups/';
